import { api } from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { 
    FreightResponse,
    FreightParams,
} from "@/interface/management/mg_freight/index";

export const useFreight = (params: FreightParams) => {
    const { searchType, search, dateFrom, dateTo, exactMatch, page, size } = params;
    return useQuery<FreightResponse>({
        queryKey: ["freight", searchType, search, dateFrom, dateTo, exactMatch, page, size],
        queryFn: async () => {
            const response = await api.get("/freight", {
                params: { searchType, search, dateFrom, dateTo, exactMatch, page, size }
            });
            return response.data;
        },
        gcTime: 0,
        refetchOnMount: true,
    });
};
